import { useState } from 'react';
import { useCart } from '../contexts/CartContext';
import CartModal from './CartModal';

export default function CartButton() {
  const [isOpen, setIsOpen] = useState(false);
  const { getItemCount } = useCart();
  const itemCount = getItemCount();

  return (
    <>
      <button
        onClick={() => setIsOpen(true)}
        className="fixed bottom-6 left-6 z-50 group"
      >
        <div className="relative">
          {/* Pulse Animation */}
          {itemCount > 0 && (
            <div className="absolute inset-0 bg-teal-500 rounded-full animate-ping opacity-75"></div>
          )}
          
          {/* Button */}
          <div className="relative w-16 h-16 bg-gradient-to-br from-teal-400 to-teal-600 rounded-full flex items-center justify-center shadow-2xl hover:shadow-teal-500/50 transition-all duration-300 hover:scale-110 cursor-pointer">
            <i className="ri-shopping-cart-line text-3xl text-white"></i>
          </div>

          {/* Item Count Badge */}
          {itemCount > 0 && (
            <div className="absolute -top-1 -right-1 w-6 h-6 bg-red-500 rounded-full flex items-center justify-center border-2 border-white">
              <span className="text-white text-xs font-bold">{itemCount}</span>
            </div>
          )}
        </div>
      </button>

      <CartModal isOpen={isOpen} onClose={() => setIsOpen(false)} />
    </>
  );
}
